import { createFileRoute } from '@tanstack/react-router';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@upme/ui/components/tabs';
import { MorningGeneralTab } from '../../features/morning/components/general-tab';
import { MorningHolidaysTab } from '../../features/morning/components/holidays-tab';
import { MorningImagesTab } from '../../features/morning/components/images-tab';
import { MorningPhrasesTab } from '../../features/morning/components/phrases-tab';
import { MorningPreviewTab } from '../../features/morning/components/preview-tab';
import { MorningSlotsTab } from '../../features/morning/components/slots-tab';

export const Route = createFileRoute('/_authenticated/morning-digest')({
  component: MorningDigestPage,
});

function MorningDigestPage() {
  return (
    <div className="p-6">
      <h1 className="mb-4 text-2xl font-semibold">Утренняя рассылка</h1>
      <Tabs defaultValue="general">
        <TabsList>
          <TabsTrigger value="general">Общие</TabsTrigger>
          <TabsTrigger value="images">Картинки</TabsTrigger>
          <TabsTrigger value="greetings">Приветствия</TabsTrigger>
          <TabsTrigger value="ctas">Призывы</TabsTrigger>
          <TabsTrigger value="holidays">Праздники</TabsTrigger>
          <TabsTrigger value="slots">Слоты</TabsTrigger>
          <TabsTrigger value="preview">Превью</TabsTrigger>
        </TabsList>
        <TabsContent value="general">
          <MorningGeneralTab />
        </TabsContent>
        <TabsContent value="images">
          <MorningImagesTab />
        </TabsContent>
        <TabsContent value="greetings">
          <MorningPhrasesTab kind="GREETING" />
        </TabsContent>
        <TabsContent value="ctas">
          <MorningPhrasesTab kind="CTA" />
        </TabsContent>
        <TabsContent value="holidays">
          <MorningHolidaysTab />
        </TabsContent>
        <TabsContent value="slots">
          <MorningSlotsTab />
        </TabsContent>
        <TabsContent value="preview">
          <MorningPreviewTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
